import { TemplatePreviewMode } from '../../shared/model/TemplatePreviewMode.enum';

export const getEJSWrapperWidthHeight = (preveiwMode: TemplatePreviewMode) => {
  switch (preveiwMode) {
    case TemplatePreviewMode.MOBILE:
      return {
        width: '93%',
        height: '97%',
      };
    case TemplatePreviewMode.TABLET:
      return {
        width: '94%',
        height: '92%',
      };
    case TemplatePreviewMode.DESKTOP:
      return {
        width: '78%',
        height: '86%',
      };
  }
};
